import React from 'react';
import {
    AssigneeDropdown,
    AssigneeOption,
    AssigneeAvatar,
    UserName,
    // Assuming a Button or similar styled component might be needed for "Unassign",
    // or we can style AssigneeOption conditionally. For now, reusing AssigneeOption.
} from '../styles/CardModal.styles'; // Ensure styles are imported if new ones are added, or use existing

const AssigneePicker = ({
    members = {},
    onAssign,
    onClose,
    onUnassign, // New prop for unassigning
    assignee // New prop to know if there's a current assignee
}) => {
    const renderMembers = () => {
        const memberEntries = Object.entries(members);
        const options = [];

        // Add "Unassign" option if someone is assigned
        if (assignee && onUnassign) {
            options.push(
                <AssigneeOption
                    key="unassign-option"
                    onClick={() => {
                        onUnassign();
                        onClose(); // Close picker after action
                    }}
                    // Add a specific class or style if needed to differentiate
                    // For example, className="unassign-option"
                >
                    {/* Optionally, add an icon for unassigning */}
                    <UserName style={{ fontStyle: 'italic' }}>Remove assignee</UserName>
                </AssigneeOption>
            );
        }

        if (memberEntries.length === 0 && !assignee) { // Modified condition
            options.push(
                <AssigneeOption key="no-members-option" className="disabled"> {/* Added className for potential styling */}
                    <UserName>No members available</UserName>
                </AssigneeOption>
            );
        } else {
            memberEntries.forEach(([userId, memberData]) => {
                // Do not show the currently assigned user in the list of assignable members
                // or visually indicate they are already assigned if preferred.
                // For now, let's assume clicking them again does nothing or re-assigns (current behavior).
                options.push(
                    <AssigneeOption
                        key={userId}
                        onClick={() => {
                            // Prevent re-assigning the same user if they are already assigned.
                            // Or, allow it if the desired behavior is just to close the picker.
                            if (assignee && assignee.uid === userId) {
                                onClose();
                                return;
                            }
                            onAssign(userId);
                            onClose();
                        }}
                    >
                        <AssigneeAvatar src={memberData?.photoURL}>
                            {!memberData?.photoURL && memberData?.displayName?.charAt(0)}
                        </AssigneeAvatar>
                        <UserName>
                            {memberData?.displayName || memberData?.email || 'Unknown User'}
                        </UserName>
                        {/* Optionally, indicate if this user is the current assignee */}
                        {assignee && assignee.uid === userId && (
                            <span style={{ marginLeft: 'auto', fontSize: '0.8em', color: '#B6C2CF' }}>(Assigned)</span>
                        )}
                    </AssigneeOption>
                );
            });
        }
        return options;
    };

    return (
        <AssigneeDropdown>
            {renderMembers()}
        </AssigneeDropdown>
    );
};

export default AssigneePicker;